import styled from 'styled-components';
import { Button, Space, Tag } from 'antd';

export const NewTag = styled(Tag)`
  margin-inline-end: 0;
`;

export const AppliedDashboardStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  max-width: 332px;

  > button:last-child {
    flex-shrink: 0;
  }
`;

export const AppliedDashboardButton = styled(Button)`
  flex: 0 1 auto;
  min-width: 0;
  max-width: 300px;
  text-align: left;

  > span:not(.anticon) {
    display: block;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const PickerContent = styled(Space)`
  width: 100%;
`;

export const DashboardList = styled.div`
  max-height: 55vh;
  overflow-y: auto;
`;

export const DashboardButton = styled(Button)`
  height: auto;
  white-space: normal;
  text-align: left;
`;
